import axios from "axios";

export const deleteBookingDisambiguationJimpi =  async (disambiguationId: string | undefined): Promise<boolean> => {
    const response = await axios.delete(`/booking/import/deleteDisambiguationBooking`, {params: {disambiguationId}});
    return response.data;
};

export default deleteBookingDisambiguationJimpi;
